/** @internal */
export const isWindowUndefined = () => typeof window === 'undefined';
